//getter

 export const showState = state => {
 	console.log(state)
 	alert(state.msg)
    //return state
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js